import * as tslib_1 from "tslib";
import { throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { BaseService } from '../base.service';
import { OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Paging } from '../../models/latipay/paging.model';
import { Headers, Http, RequestOptions } from '@angular/http';
var AppActivityConditionService = /** @class */ (function (_super) {
    tslib_1.__extends(AppActivityConditionService, _super);
    function AppActivityConditionService(http, httpP) {
        var _this = _super.call(this, 'app-activity-condition', http) || this;
        _this.http = http;
        _this.httpP = httpP;
        return _this;
    }
    AppActivityConditionService.prototype.ngOnInit = function () {
    };
    AppActivityConditionService.prototype.getAllCategory = function (searchStr) {
        searchStr = searchStr ? searchStr : '';
        var tempPaging = new Paging({ pageNumber: 1, pageSize: 1000000 });
        var idSortStr = '&sort=queue,asc';
        return this.http.get(this.url + "?" + tempPaging.getPagingStr() + (this.embeddedStr + searchStr + idSortStr)).pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    AppActivityConditionService.prototype.getAllCoupons = function (walletId) {
        var str = '&f_walletId=' + walletId;
        var tempPaging = new Paging({ pageNumber: 1, pageSize: 1000000 });
        var idSortStr = '&sort=queue,asc';
        return this.http.get(this.url + "?" + tempPaging.getPagingStr() + str).pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    AppActivityConditionService.prototype.getAllTopicByPaging = function (searchCondition, sortOprions, paging) {
        if (!searchCondition) {
            searchCondition = '';
        }
        var sortStr = sortOprions.getSortString();
        return this.http.get("" + this.url + sortStr + paging.getPagingStr() + (this.embeddedStr + searchCondition) + "&sort=queue,asc").pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    AppActivityConditionService.prototype.getAllByBusinessIdByPaging = function (searchCondition, businessId, paging) {
        if (!searchCondition) {
            searchCondition = '';
        }
        return this.http.get(this.url + "?" + paging.getPagingStr() + (this.embeddedStr + searchCondition) + "&sort=id,desc" + (businessId ? "&f_businessId=" + businessId + "&f_businessId_op==" : '')).pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    AppActivityConditionService.prototype.getAllByWalletIdsByPaging = function (walletIds, searchCondition, paging) {
        var sortStr = '&sort=id,asc';
        var walletIdsStr = '';
        if (walletIds) {
            walletIds.forEach(function (id) {
                walletIdsStr += "&f_acceptedMerchants=" + id;
            });
        }
        if (walletIdsStr) {
            walletIdsStr += '&f_acceptedMerchants_op=IN';
        }
        return this.http.get(this.url + "?" + paging.getPagingStr() + walletIdsStr + sortStr + searchCondition).pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    AppActivityConditionService.prototype.publishCouponById = function (id) {
        return this.http.post(this.url + "/" + id + "/dispatch", '').pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    // updatePromoCategoryList(data: PromoCategory[], token: string) {
    //     const header: Headers = new Headers();
    //     header.append('Content-Type', 'application/json');
    //     header.append('Authorization', token);
    //     const options = new RequestOptions({headers: header});
    //     return this.httpP.post(`${this.url}/${promoId}/update-link`, value, options).pipe(
    //         map((response) => response), catchError((res: any) => observableThrowError(res)));
    // }
    AppActivityConditionService.prototype.swapCategoryQueue = function (origin, target) {
        return this.http.post(this.url + "/" + origin + "/" + target + "/swap", '').pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    AppActivityConditionService.prototype.deleteWalletByCouponId = function (id) {
        return this.http.post(this.url + "/" + id + "/delete-wallets", '').pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    AppActivityConditionService.prototype.updatePromoCategoryList = function (value, token) {
        var header = new Headers();
        header.append('Content-Type', 'application/json');
        header.append('Authorization', token);
        var options = new RequestOptions({ headers: header });
        return this.httpP.post(this.url + "/update-sort", value, options).pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    AppActivityConditionService.prototype.getAllCondtion = function (searchStr) {
        searchStr = searchStr ? searchStr : '';
        var tempPaging = new Paging({ pageNumber: 1, pageSize: 1000000 });
        var idSortStr = '&sort=queue,asc';
        var embed = '&embedded=prize';
        return this.http.get(this.url + "?" + tempPaging.getPagingStr() + (embed + searchStr)).pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    AppActivityConditionService.prototype.getAllSelectBusinessCondtion = function (prizeId, searchStr) {
        searchStr = searchStr ? searchStr : '';
        var tempPaging = new Paging({ pageNumber: 1, pageSize: 1000000 });
        var idSortStr = '&sort=queue,asc';
        var embed = '&embedded=prize';
        return this.http.get(this.url + "/" + prizeId + "//get-business?" + tempPaging.getPagingStr() + (embed + searchStr)).pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    AppActivityConditionService.prototype.getAllBusinessCondtion = function (walletId, searchStr) {
        searchStr = searchStr ? searchStr : '';
        var tempPaging = new Paging({ pageNumber: 1, pageSize: 1000000 });
        var idSortStr = '&sort=queue,asc';
        var embed = '&embedded=prize';
        return this.http.get(this.url + "/business-condition/" + walletId + "?" + tempPaging.getPagingStr() + (embed + searchStr)).pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    AppActivityConditionService.prototype.getAllConditionByPaging = function (searchCondition, activityId, paging) {
        var idSortStr = '&sort=createdOn,desc';
        if (!searchCondition) {
            searchCondition = '';
        }
        var embedStr = '&embedded=prize';
        var str = '&f_prize.activityId_op==&f_prize.activityId=' + activityId;
        return this.http.get(this.url + "?" + paging.getPagingStr() + (this.embeddedStr + searchCondition + idSortStr + str + embedStr)).pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    AppActivityConditionService.prototype.updateStatus = function (id, enabled) {
        return this.http.post(this.url + "/" + id + "/" + enabled + "/update-status", '').pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    AppActivityConditionService.prototype.remove = function (id) {
        return this.http.post(this.url + "/" + id + "/remove", '').pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    AppActivityConditionService.prototype.addAll = function (id, activityId) {
        return this.http.post(this.url + "/" + id + "/" + activityId + "/add-all", '').pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    AppActivityConditionService.prototype.addAllOther = function (id) {
        return this.http.post(this.url + "/" + id + "/add-all-latipay", '').pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    AppActivityConditionService.prototype.deleteByPrizeIdAndActivityId = function (id, activityId) {
        return this.http.post(this.url + "/" + id + "/" + activityId + "/delete-all", '').pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    AppActivityConditionService.prototype.addWeight = function (prizeId, weight) {
        return this.http.post(this.url + "/" + prizeId + "/" + weight + "/add-weight", '').pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    AppActivityConditionService.prototype.reduceWeight = function (prizeId, weight) {
        return this.http.post(this.url + "/" + prizeId + "/" + weight + "/reduce-weight", '').pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    AppActivityConditionService.prototype.adjustMinAmount = function (prizeId, minAmount) {
        return this.http.post(this.url + "/" + prizeId + "/" + minAmount + "/adjust-min-amount", '').pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    AppActivityConditionService.prototype.addWallet = function (value) {
        return this.http.post("" + this.url, value).pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    AppActivityConditionService.prototype.updateWalletByList = function (value, token) {
        var header = new Headers();
        header.append('Content-Type', 'application/json');
        header.append('Authorization', token);
        var options = new RequestOptions({ headers: header });
        return this.httpP.post(this.url + "/update-condition", value, options).pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    return AppActivityConditionService;
}(BaseService));
export { AppActivityConditionService };
